/* esm.sh - micromark@4.0.2/lib/postprocess */
import{subtokenize as r}from"micromark-util-subtokenize";function e(o){for(;!r(o););return o}export{e as postprocess};
//# sourceMappingURL=postprocess.mjs.map